import { lazy } from 'react'

/**
 * Módulo: Debugging
 *
 * Bug tracker interno del equipo (ADR 051) y —desde ADR 064— la ÚNICA cola de
 * corrección del proyecto: lo que encuentra una persona y lo que encuentra la
 * IA entran acá, por la misma aduana. El agente nocturno lo consume por el MCP
 * `debuggingMcp`; los hallazgos de IA nacen en `informe` y no llegan a la cola
 * hasta que alguien con `debugging.autorizar` los aprueba.
 *
 * ─── Por qué existe este archivo (ADR 064, tramo 5) ────────────────────────
 *
 * Hasta el 7-ago-2026 `debugging` era un módulo ZOMBIE: tenía `lib/` con la
 * lógica y sus tests, pero **no tenía `config.js`, no estaba en
 * `src/modules/index.js` y su página colgaba de `plataforma/pages/`**. O sea:
 * existía como carpeta, no como módulo. El ADR 064 lo declaró precondición —
 * *"elevarlo a 'única cola del proyecto' sin regularizarlo es promover deuda"*.
 *
 * ─── Gating ────────────────────────────────────────────────────────────────
 *
 * Por permiso-módulo `debugging` (catálogo en `src/core/lib/modulos.js`), con
 * tres funciones que implementan el triage gate: `ver`, `crear` (informado) y
 * `autorizar`. (`crearAprobado` — crear directo en 'nuevo' sin revisión — se
 * eliminó el 11-ago-2026 por decisión de Mariano: todos los reportes nacen
 * informados y la única puerta a la cola es la aprobación explícita.)
 *
 * ⚠️ El ítem del sidebar vive en `plataforma-operacion/config.js` (split del
 * 7-jul-2026: los grupos del sidebar declaran los ítems, los módulos declaran
 * las rutas). Hasta el 7-ago ese ítem se gateaba con `observabilidad`, que es
 * OTRO módulo: quien tenía `debugging.ver` y no `observabilidad.ver` no veía la
 * entrada, y al revés la veía sin poder usarla. Corregido en el mismo PR.
 *
 * Interno de Milbrands (`milbrandsInterno: true`): el ítem cae bajo el
 * subheader "Milbrands Operaciones" del sidebar.
 */
export default {
  id: 'debugging',
  nombre: 'Debugging',
  descripcion: 'Bug tracker interno y única cola de corrección del proyecto (ADR 051 + ADR 064)',
  icono: 'activity',
  tipo: 'admin',
  version: '1.0.0',

  milbrandsInterno: true,
  permisoModulos: ['debugging'],

  routes: [
    { path: 'debugging', component: lazy(() => import('./pages/DebuggingPage')) },
    // Deep-link de las notificaciones (campanita) al reporte puntual — sin esta
    // ruta, /debugging/:id no matcheaba nada y el router caía al inicio
    // (reporte ybH7tKaP). Molde: auto-meeting/:tipoId (misma page, param opcional).
    { path: 'debugging/:reportId', component: lazy(() => import('./pages/DebuggingPage')) },
  ],

  // Sin ítems propios: el del sidebar lo aporta `plataforma-operacion` (ver
  // arriba). Mismo patrón que `proyectos` y los ítems mudados en el split.
  menuItems: [],

  features: ['debug-reports'],
}
